<template>
  <div class="street-view-container" v-if="loadingBuilding === 0 && loadingCoordinate === 0">
    <gmap-street-view-panorama
      class="pano"
      :position="position"
      :pano="pano"
      :pov="pov"
      :zoom="zoom">
    </gmap-street-view-panorama>
  </div>
</template>

<script>
  import gql from 'graphql-tag';

  const urlRegex = /\/@([-0-9.]+),([-0-9.]+),[-0-9.]+a,[-0-9.]+y,([-0-9.]+)h,([-0-9.]+)t\/.*!1s(.*)!2e/;

  export default {
    props: ['pisBuildingId'],
    data() {
      return {
        loadingBuilding: 0,
        building: null,
        loadingCoordinate: 0,
        coordinate: null,
        zoom: 0,
      };
    },
    computed: {
      pano() {
        if (this.building) {
          const match = urlRegex.exec(this.building.streetViewUrl);
          if (match) {
            return match[5];
          }
        }
        return null;
      },
      position() {
        if (this.building && this.building.streetViewUrl) {
          return {};
        }

        if (this.coordinate) {
          const c = this.coordinate;
          if (c && c.lat && c.lng) {
            return {
              lat: c.lat,
              lng: c.lng,
            };
          }
        }

        return {};
      },
      pov() {
        if (this.building) {
          const match = urlRegex.exec(this.building.streetViewUrl);
          if (match) {
            return {
              heading: parseFloat(match[3], 10),
              pitch: parseFloat(match[4], 10) - 90,
            };
          }
        }
        return {
          pitch: 20,
          heading: 0,
        };
      },
    },
    apollo: {
      building: {
        client: 'building',
        fetchPolicy: 'network-only',
        query: gql`
          query ($pisBuildingId: ID!) {
            building(id: $pisBuildingId) {
              id
              streetViewUrl
            }
          }
        `,
        variables() {
          return { pisBuildingId: this.pisBuildingId };
        },
        skip() {
          return !this.pisBuildingId;
        },
        loadingKey: 'loadingBuilding',
      },
      coordinate: {
        client: 'api',
        fetchPolicy: 'network-only',
        query: gql`
          query ($pisBuildingId: ID!) {
            pisBuilding(id: $pisBuildingId) {
              id
              unicornBuildings {
                coordinate { 
                  lat
                  lng
                }
              }
            }
          }
        `,
        variables() {
          return { pisBuildingId: this.pisBuildingId };
        },
        update(data) {
          if (data.pisBuilding && data.pisBuilding.unicornBuildings.length) {
            return data.pisBuilding.unicornBuildings[0].coordinate;
          }
          return null;
        },
        skip() {
          return !this.pisBuildingId;
        },
        loadingKey: 'loadingCoordinate',
      },
    },
  };
</script>
<style>
  .vue-street-view-pano {
    width: 100%;
    height: 450px;
  }
</style>

<style scoped>
  .title {
    text-align: center;
    font-size: 25px;
    line-height: 32px;
  }

  .street-view-container {
    width: 100%;
  }

  .pano {
    width: 100%;
    height: 450px;
  }
</style>
